export const ua_uk = {
  '404': {
    TITLE: 'Ой... ',
    PAGENOTFOUND: 'Сторінку не знайдено',
    BUTTON: 'Повернутися на головну',
    RECIPES: 'Відкрийте наші рецепти'
  },
  HOME: {
    SHOWCASE: 'Готувати за рецептами',
    CATCH_PHRASE: '',
    SHOWCASE_SEE_ALL: 'Переглянути всі рецепти',
    MAGAZINE: { TITLE: 'НАЙКРАЩЕ', BUTTON: 'Відкрийте для себе Légumiz' },
    OUR_VEGETABLES: 'Наші овочі для…',
    SOCIAL_WALL: 'Разом поділимося пристрастю до рослинної їжі',
    FAQ_TITLE: 'Ваші запитання',
    FAQ_SEE_MORE: 'Дивитися більше',
    FLOWBOX: 'Поділіться смачними моментами з #mybonduelle'
  },
  SELECT: { DEFAULT_VALUE: 'Фільтрувати за ' },
  MENU: {
    CONTACT_US: "Зв'язатися з нами",
    MY_ACCOUNT: 'Мій обліковий запис',
    GOOD_DEALS: 'Вигідні пропозиції',
    NEWSLETTER: 'Розсилка від Bonduelle',
    SUBMENU_TOGGLE: 'Підменю {{label}}'
  },
  FOOTER: {
    LINK: {
      BONDUELLE: 'Bonduelle.ua',
      CREDITS: 'Авторські права',
      LEGAL_NOTICE: 'Правова інформація',
      TERMS_OF_SALES: 'Умови продажу',
      COOKIES: 'Файли cookie',
      SITEMAP: 'Карта сайту',
      PRIVACY_POLICY: 'Politika privatnosti',
      ALL_RIGHTS_RESERVED: '2023 © Усі права захищено'
    },
    HISTORY: {
      TITLE: 'Bonduelle, з 1853 року',
      TEXT: "Сімейний бізнес протягом 7 поколінь, Bonduelle розвиває аграрні ланцюги створення вартості, підтримуючи своїх фермерів-партнерів в еволюції їхніх сільськогосподарських практик для вирішення завдань, пов'язаних із якістю, стійкістю культур та збереженням сільськогосподарських ресурсів.<br><br>Від ферми до столу ми впроваджуємо інновації, щоб розробляти рослинні рішення на основі овочів, які відповідають очікуванням споживачів і сприяють розвитку рослинного харчування."
    },
    NEWSLETTER: {
      TITLE: 'Спільнота Bonduelle',
      TEXT: 'Я погоджуюся отримувати розсилку «Все про овочі від Bonduelle» (новини, акції, конкурси, статті ...)',
      PLACEHOLDER: 'Ваша електронна пошта',
      GDPR_LINK: 'Докладніше про керування вашими даними'
    }
  },
  PRODUCTS: 'Продукти',
  MAGAZINE: {
    HOME: 'Ласкаво просимо до журналу',
    CATCH_PHRASE: 'Дізнавайтесь новини зі світу овочів разом із Bonduelle!',
    MENU: { BONDUELLE_LINK: 'Перейти на bonduelle.ua' },
    SHOWCASE: 'Вітрина',
    PREVIOUS_ARTICLES: 'Попередні статті',
    PREVIOUS_ARTICLES_SEE_ALL: 'Переглянути всі наші статті',
    PREVIOUS_EDITIONS: 'Наші попередні випуски',
    PREVIOUS_EDITIONS_SEE_ALL: 'Переглянути більше випусків',
    PREVIOUS_ARTICLES_BY_CATEGORY: 'Попередні статті за категорією',
    RUBRIC: {
      SEE_ALL: 'Переглянути всі рецепти',
      SEE_ALL_ARTICLES: 'Переглянути всі статті',
      ON: 'Статті про'
    },
    RUBRIC_COOK: { ON: 'Рецепти з' },
    ARTICLE: { JOIN_US: 'Приєднуйтесь до нас', READ_ALSO: 'Також читайте' },
    RECIPE: {
      INGREDIENTS: 'Інгредієнти',
      INGREDIENTS_LABEL_DESC: 'для {{value}} осіб',
      INGREDIENTS_LABEL_ONE_DESC: 'для {{value}} особи',
      INGREDIENTS_LABEL: 'Інгредієнти для {{value}} осіб',
      INGREDIENTS_LABEL_ONE: 'Інгредієнти для {{value}} особи',
      PEOPLES: '{{value}} осіб',
      PEOPLE: '{{value}} людей',
      DIFFICULTY: { EASY: 'Легко', MEDIUM: 'Середньо', HARD: 'Складно' },
      COST: { CHEAP: 'Недорого', EXPENSIVE: 'Дорого' },
      TIMING: { MIN: 'хв', HOURS: 'години' },
      STEP: 'Кроки ',
      DISCOVER_ALSO: 'Також відкрийте для себе...'
    }
  },
  ARTICLE: { DISCOVER_ALSO: 'Також дізнайтесь ...', INGREDIENTS: 'Інгредієнти' },
  SF: {
    SLIDE: { DISCOVER: 'Відкрити' },
    SEARCH: { PLACEHOLDER: 'Пошук', ALL: 'Усе' },
    NEWSLETTER: {
      BTN_LABEL: 'Я реєструюся\n',
      PLACEHOLDER: 'Ваша електронна пошта',
      ERROR_MESSAGE: 'Невірна електронна пошта',
      ALREADY_SUBSCRIBED: 'Ви вже підписані',
      GDPR: {
        TXT: 'Докладніше про обробку ваших даних',
        LINK: 'Політикою конфіденційності'
      }
    },
    MONTHLY_FOLDER: { TITLE: 'Щомісячні новини' },
    MINI_NEWSLETTER: {
      PLACEHOLDER: 'Ваша електронна пошта',
      GDPR: {
        TXT: 'Докладніше про обробку ваших даних',
        LINK: 'Політикою конфіденційності'
      }
    },
    SOCIALITEM: {
      SHARE: 'Поділитися',
      COMMENT: 'Коментар',
      BONDUELLE: 'Bonduelle'
    },
    SEARCHRECIPE: { DISCOVER_ALL: 'Шукати серед усіх рецептів!' },
    FORM: {
      ERROR: 'Невірне поле',
      PHOTO: {
        ADD: 'Перетягніть свої фотографії сюди',
        DELETE: 'Видалити зображення',
        SEE: 'Переглянути',
        ADD_SUB: 'або натисніть, щоб вибрати файли'
      }
    }
  },
  CORPORATE: {
    COMPANY_STORY: 'Історія компанії',
    CSR_COMMITMENT: 'корпоративної соціальної відповідальності',
    VEGETABLE_INNOVATIONS: 'Рослинні інновації',
    NEWS: 'Усі новини',
    SEE_MORE: 'Переглянути більше статей',
    ON: 'Статті про',
    NUMBERS: "Наші зобов'язання, у цифрах"
  },
  NEWSLETTER: {
    TITLE: 'Підписатися на розсилку',
    SUBTITLE: 'Вигідні пропозиції, кулінарне натхнення та трохи культури!'
  },
  ROUTES: {
    products: 'produkty',
    news: 'novyny',
    'since-1853': 'z-1853-roku',
    'field-plate': 'vid-polja-do-tarilky',
    'company-story': 'istoriia-kompanii',
    'csr-commitments': 'zoboviazannia-zi-staloho-rozvytku',
    'vegetal-innovations': 'roslynni-innovatsii',
    magazine: 'zhurnal',
    all: 'vsi',
    article: 'stattia',
    cook: 'hotuvaty',
    cultivate: 'vyroshchuvaty',
    explore: 'doslidzhuvaty',
    recipe: 'ochikuite-retsept',
    recipes: 'retsepty',
    'recipes-home': 'holovna-storinka-retseptiv',
    r: 'r',
    credits: 'avtorski-prava',
    'legal-notice': 'yurydychna-informatsiia',
    'terms-of-sales': 'umovy-prodazhu',
    cookies: 'faily-cookie',
    sitemap: 'mapa-saytu',
    'privacy-policy': 'polityka-konfidentsiinosti',
    'all-rights-reserved': 'vsi-prava-zakhyshcheni',
    search: 'poshuk',
    'articles-search': 'stattia',
    vegetables: 'ovochi',
    p: 'p',
    contact: 'kontakty',
    'info-product': 'zapyt-pro-produkt',
    'note-product': 'zauvazhennia-shchodo-produktu',
    suggestion: 'propozytsiia',
    'other-request': 'zauvazhennia-shchodo-produktu',
    faq: 'poshyreni-zapytannia',
    'all-themes': 'vsi-temy',
    'products-search': 'poshuk-produktiv',
    recipesearch: 'poshuk-retseptiv',
    'product-news': 'novyny-produktiv',
    'good-deals': 'vyhidni-propozytsii',
    'not-found': 'ne-znaideno',
    'menu-page': 'natkhnennya',
    'menu-one': 'zhyvit-zdorovo',
    'menu-two': 'hotuyte-shche-smachnishe',
    'menu-three': 'bud-te-u-trendi',
    'menu-four': 'bud-te-kreatyvnymy',
    'menu-external': '',
    'theme-pasta-rice': '',
    'theme-bowls': '',
    'theme-soup': '',
    'theme-snack': '',
    'theme-sauce': '',
    'theme-unique-plate': '',
    'theme-over': 'zavershennia-temy',
    'theme-legumin': 'bobovi',
    'theme-ingredients-recipes': '',
    'theme-cook-plate': ''
  },
  BREAD: {
    products: 'produkty',
    news: 'novyny',
    'since-1853': 'z-1853-roku',
    'field-plate': 'vid-polja-do-tarilky',
    'company-story': 'istoriia-kompanii',
    'csr-commitments': 'zoboviazannia-zi-staloho-rozvytku',
    'vegetal-innovations': 'roslynni-innovatsii',
    magazine: 'zhurnal',
    all: 'vsi',
    article: 'stattia',
    cook: 'hotuvaty',
    cultivate: 'vyroshchuvaty',
    explore: 'doslidzhuvaty',
    recipe: 'ochikuite-retsept',
    recipes: 'retsepty',
    'recipes-home': 'holovna-storinka-retseptiv',
    'articles-search': 'stattia',
    search: 'poshuk',
    vegetables: 'ovochi',
    contact: 'kontakty',
    'info-product': 'zapyt-pro-produkt',
    'note-product': 'zauvazhennia-shchodo-produktu',
    suggestion: 'propozytsiia',
    'other-request': 'zauvazhennia-shchodo-produktu',
    faq: 'poshyreni-zapytannia',
    'all-themes': 'vsi-temy',
    'products-search': 'poshuk-produktiv',
    recipesearch: 'poshuk-retseptiv',
    'product-news': 'novyny-produktiv',
    'good-deals': 'vyhidni-propozytsii',
    'not-found': 'ne-znaideno',
    'menu-page': 'natkhnennya',
    'menu-one': 'Zhyvitʹ-zdorovo',
    'menu-two': 'Hotuyte-shche-smachnishe',
    'menu-three': 'Budʹte-u-trendi',
    'menu-four': 'Budʹte-kreatyvnymy'
  },
  'depuis-1853': 'stattia',
  MENU_PAGE: {
    TITLE1: 'ЖИВІТЬ ЗДОРОВО',
    TITLE2: 'ГОТУЙТЕ ЩЕ СМАЧНІШЕ',
    TITLE3: 'БУДЬТЕ У ТРЕНДІ',
    TITLE4: 'БУДЬТЕ КРЕАТИВНИМИ',
    EXTERNAL: ''
  },
  TECHNICAL: { MENU_PAGE: 'вакансії' },
  SEO: {
    TITLE: {
      MENU_ONE: '',
      MENU_TWO: '',
      MENU_THREE: '',
      MENU_FOUR: '',
      HOME: 'Bonduelle: джерело натхнення овочами та кулінарними рецептами',
      SEARCH: {
        MAIN: '{{value}} | Bonduelle',
        RECIPES: '{{value}} відсортовано за рецептом | Bonduelle',
        VEGETABLES: '{{value}} відсортовано за овочем | Bonduelle',
        ARTICLES: '{{value}} відсортовано за статтею | Bonduelle'
      },
      CONTACT: 'Контакт із клієнтською службою, інформація | Bonduelle',
      RECIPES: 'Кулінарні рецепти: суп, киш, овочева лазанья... | Bonduelle',
      RECIPE_HOME: 'Рецепти з овочами на Різдво, весілля, свята | Bonduelle',
      RECIPE: 'Рецепт {{value}} | Bonduelle',
      PRODUCTS: 'Приготовлені овочі, консервовані, заморожені для приготування | Bonduelle',
      NEWS: 'Поради, готування, як приготувати овочі | Bonduelle',
      CORPORATE: {
        NEWS: 'Останні статті, новини про овочі та кулінарію | Bonduelle',
        COMPANY_STORY: 'Представлення компанії та асоціації | Bonduelle',
        CSR_COMMITMENTS: 'Етичні цінності/принципи та зобов’язання групи | Bonduelle',
        VEGETAL_INNOVATIONS: 'Рослинні інновації: нові ферми, продукти | Bonduelle',
        FIELD_PLATE: 'Овочі: найкращі рецепти | Bonduelle',
        ARTICLE: ' {{value}} | Bonduelle',
        VEGETABLE: 'Ідея рецепта, як смачно приготувати {{value}} | Bonduelle'
      },
      PRODUCT: ' {{value}}: приготовані овочі від Bonduelle',
      MAGAZINE: {
        NEWS: 'Новини про овочі, рецепти для дорослих і дітей | Bonduelle',
        ARTICLE: '{{value}} | Legumiz | Bonduelle',
        COOK: 'Легкі та швидкі рецепти з овочами | Bonduelle',
        GROW: 'Вирощування та догляд за овочами на власному городі | Bonduelle',
        EXPLORE: 'Відкрийте нові овочі та смаки для дітей | Bonduelle',
        RECIPE: 'Рецепт {{value}} | Bonduelle'
      },
      FAQ: 'Часті запитання користувачів | Bonduelle',
      NOTFOUND: 'Помилка 404, спробуйте пізніше | Bonduelle',
      RECIPES_ALL: 'Усі наші рецепти овочевих страв.',
      RECIPETYPE: 'Кулінарний рецепт: {{value}} з овочів',
      RECIPESEASON: 'Сезонний овочевий рецепт: {{value}}',
      RECIPEPREPARATION: 'Рецепти страв: час приготування {{value}}',
      RECIPEDIFFICULTY: 'Простий рецепт з овочів: {{value}} з овочів',
      RECIPEVEGETABLE: 'Простий рецепт на основі {{value}}',
      RECIPECOST: 'Рецепт страви та овочів {{value}}',
      RECIPEDISH: 'Рецепти страв і овочів для {{value}}',
      RECIPEDESC: 'Рецепт страви та овочів {{value}}',
      '2RECIPEFACETS': 'Рецепт страви {{value}}',
      '4RECIPEFACETS': 'Рецепт страви {{value}}',
      PRODUCTSEASON: 'Простий сезонний овочевий рецепт: {{value}}',
      PRODUCTTECHNO: 'Простий овочевий рецепт {{value}}',
      PRODUCTVEGETABLE: 'Простий овочевий рецепт на основі {{value}}',
      PRODUCTRANGE: 'Простий овочевий рецепт з асортименту {{value}}',
      THEME_ALL: '',
      THEME_STARTER: 'Ідеї з овочів для приготування закусок',
      THEME_SALAD: 'Овочеві ідеї для літніх салатів',
      THEME_CAN: '',
      THEME_FROZEN: '',
      THEME_READY_MEALS: '',
      THEME_BIO: '',
      THEME_VEGETABLES: '',
      THEME_RECIPE: 'Овочеві ідеї для швидких і простих рецептів',
      THEME_PLATE: 'Овочеві ідеї для гарячих і холодних страв',
      THEME_ACC: "Овочеві ідеї для м'яса та риби",
      THEME_SNACK: 'Овочеві ідеї для швидких рецептів',
      RECIPE_THEME1: '',
      '2PRODUCTSFACETS': 'Овочевий рецепт {{value}}'
    },
    DESCRIPTION: {
      MENU_ONE: '',
      MENU_TWO: '',
      MENU_THREE: '',
      MENU_FOUR: '',
      HOME: 'Консервація, заморожені продукти, салати, сирі овочі — відкрийте для себе наші чудові овочі та ідеї рецептів для натхнення ваших смачних страв. Bonduelle: джерело натхнення овочами та рецептами.',
      SEARCH: {
        MAIN: 'Відкрийте наші ідеї рецептів та овочів для {{value}}. Простi й смачні рецепти. Приготовані овочі.',
        RECIPES: 'Усі наші {{value}} відсортовані за рецептом. Простi та смачні рецепти. Приготовані овочі.',
        VEGETABLES: 'Усі наші {{value}} відсортовані за овочем. Простi та смачні рецепти. Приготовані овочі.',
        ARTICLES: 'Усі наші {{value}} відсортовані за статтею. Простi та смачні рецепти. Приготовані овочі.'
      },
      CONTACT: 'Є запитання? Потрібна інформація про продукт, послугу або поточну акцію? Ви можете звернутися до нашої служби підтримки клієнтів. Гарантована відповідь протягом 48 годин.',
      RECIPES: 'Відкрийте для себе смачні рецепти з овочами. Потіште своїх близьких, приготувавши їм прості страви. Простi та смачні рецепти. Приготовані овочі.',
      RECIPE_HOME: 'Відкрийте для себе смачні овочеві рецепти до свят. Потіште своїх близьких у цю особливу нагоду. Простi та смачні рецепти. Приготовані овочі.',
      RECIPE: '',
      PRODUCTS: 'Наш широкий асортимент овочів дозволяє вам готувати смачні, прості та збалансовані страви. Простi та смачні рецепти. Приготовані овочі.',
      NEWS: 'Дізнайтеся, як правильно готувати овочі та ефективно їх використовувати для створення смачних страв. Простi та смачні рецепти. Приготовані овочі.',
      CORPORATE: {
        NEWS: 'Останні новини зі світу сільського господарства, інновацій у вирощуванні рослин, боротьби з харчовими відходами та простого способу краще харчуватися. Простi та смачні рецепти. Приготовані овочі.',
        COMPANY_STORY: 'Хочете дізнатися більше про світ овочів, аграрну та рослинну сферу? Ми відкриємо вам це у нашому блозі. Простi та смачні рецепти. Приготовані овочі.',
        CSR_COMMITMENTS: 'Цікавитесь, як вирощуються наші овочі, звідки вони, як ми дбаємо про довкілля? Тут ви знайдете відповіді на всі запитання щодо овочів.',
        VEGETAL_INNOVATIONS: 'Інновації у вирощуванні рослин — у центрі нашої уваги. Нові екологічні способи вирощування, менше відходів... Простi та смачні рецепти. Приготовані овочі.',
        VEGETABLE: '',
        FIELD_PLATE: 'Відкрийте для себе наші смачні рецепти. Вони сподобаються кожному. Простi та смачні рецепти. Приготовані овочі.',
        ARTICLE: ''
      },
      PRODUCT: '{{value}} для приготування смачних страв і щоб потішити своїх близьких. Простi та смачні рецепти. Приготовані овочі.',
      MAGAZINE: {
        NEWS: 'Усі новини, інформація про овочі, збалансовані кулінарні рецепти. Простi та смачні рецепти. Приготовані овочі.',
        ARTICLE: '',
        COOK: 'Наші смачні рецепти порадують кожного — відкрийте їх на нашому сайті. Простi та смачні рецепти. Приготовані овочі.',
        GROW: 'Хочете самостійно вирощувати овочі у власному городі? Ознайомтеся з нашими порадами та підказками щодо вирощування й догляду за овочами. Приготовані овочі.\n',
        EXPLORE: 'Відкрийте дітям нові сорти овочів через прості та ефективні рецепти. Легкі та смачні рецепти. Приготовані овочі.',
        RECIPE: ''
      },
      FAQ: 'Маєте запитання? Ми зібрали найпоширеніші питання від користувачів, щоб найкраще задовольнити ваші очікування.',
      PAGE: 'сторінка',
      RECIPETYPE: 'Відкрийте наші рецепти {{value}} та дізнайтесь, як смачно готувати овочі. Ідеї вегетаріанських, швидких, оригінальних і простих страв.',
      RECIPESEASON: 'Відкрийте наші рецепти {{value}} та дізнайтесь, як смачно готувати овочі. Ідеї вегетаріанських, швидких, оригінальних і простих страв.',
      RECIPEPREPARATION: 'Відкрийте наші рецепти {{value}} та дізнайтесь, як смачно готувати овочі. Ідеї вегетаріанських, швидких, оригінальних і простих страв.',
      RECIPEDIFFICULTY: 'Відкрийте наші рецепти {{value}} та дізнайтесь, як смачно готувати овочі. Ідеї вегетаріанських, швидких, оригінальних і простих страв.',
      RECIPEVEGETABLE: 'Відкрийте наші рецепти {{value}} та дізнайтесь, як смачно готувати овочі. Ідеї вегетаріанських, швидких, оригінальних і простих страв.',
      RECIPECOST: 'Відкрийте наші рецепти {{value}} та дізнайтесь, як смачно готувати овочі. Ідеї вегетаріанських, швидких, оригінальних і простих страв.',
      RECIPEDISH: 'Відкрийте наші рецепти {{value}} та дізнайтесь, як смачно готувати овочі. Ідеї вегетаріанських, швидких, оригінальних і простих страв.',
      RECIPEDESC: 'Відкрийте наші рецепти {{value}} та дізнайтесь, як смачно готувати овочі. Ідеї вегетаріанських, швидких, оригінальних і простих страв.',
      '2RECIPEFACETS': 'Відкрийте наші рецепти {{value}} та дізнайтесь, як смачно готувати овочі. Ідеї вегетаріанських, швидких, оригінальних і простих страв.',
      '4RECIPEFACETS': 'Відкрийте наші рецепти {{value}} та дізнайтесь, як смачно готувати овочі',
      PRODUCTSEASON: 'Наш широкий асортимент овочів дозволяє вам готувати смачні, прості та збалансовані рецепти. Прості та смачні рецепти. Приготовані овочі.',
      PRODUCTTECHNO: 'Наш широкий асортимент овочів дозволяє вам готувати смачні, прості та збалансовані рецепти. Прості та смачні рецепти. Приготовані овочі.',
      PRODUCTVEGETABLE: 'Наш широкий асортимент овочів дозволяє вам готувати смачні, прості та збалансовані рецепти. Прості та смачні рецепти. Приготовані овочі.',
      PRODUCTRANGE: 'Наш широкий асортимент овочів дозволяє вам готувати смачні, прості та збалансовані рецепти. Прості та смачні рецепти. Приготовані овочі.',
      THEME_ALL: 'Наш широкий асортимент овочів дозволяє вам готувати смачні, прості та збалансовані рецепти. Прості та смачні рецепти. Приготовані овочі.',
      THEME_STARTER: 'Хочете приготувати збалансовану їжу? Широкий асортимент овочів для швидких і простих рецептів перших страв на основі овочів, а також поради та підказки, які допоможуть зробити ваші страви ще смачнішими.',
      THEME_SALAD: 'Хочете приготувати збалансовану їжу? Широкий асортимент овочів для швидких і простих рецептів перших страв на основі овочів, а також поради та підказки, які допоможуть зробити ваші страви ще смачнішими.',
      THEME_CAN: '',
      THEME_FROZEN: '',
      THEME_READY_MEALS: '',
      THEME_BIO: '',
      THEME_VEGETABLES: '',
      THEME_RECIPE: 'овочі, щоб готувати смачні та збалансовані рецепти на основі швидких та простих овочів, поради та підказки, які допоможуть зробити ваші страви ще смачнішими. Швидкі та збалансовані рецепти',
      THEME_PLATE: 'Хочете приготувати збалансовану їжу? Овочі для швидкого та легкого приготування гарячих та холодних овочевих страв, поради та підказки, які зроблять ваші страви вишуканими.',
      THEME_ACC: 'овочеві гарніри на основі овочів, які швидко і легко готуються, а також поради та підказки, які допоможуть зробити ваші страви ще смачнішими. Прості, збалансовані рецепти.',
      THEME_SNACK: 'Хочете приготувати збалансовану їжу? Рецепти швидких і простих закусок на основі овочів, поради та підказки, які допоможуть зробити ваші страви ще смачнішими.',
      RECIPE_THEME1: '',
      '2PRODUCTSFACETS': 'Наш широкий асортимент овочів дозволяє готувати смачні, прості та збалансовані рецепти {{value}}. Прості, смачні рецепти. Приготовлені овочі.',
      NOTFOUND: 'Сторінку, яку ви запитували, не вдалося знайти. Запрошуємо вас здійснити новий пошук або розпочати його пізніше.'
    },
    PIPE: { SOCIETY: '| Bonduelle' },
    THEME_ALL: 'усі',
    THEME_STARTER: 'закуски',
    THEME_SALAD: 'все-для-моїх-салатів',
    THEME_CAN: '',
    THEME_FROZEN: '',
    THEME_READY_MEALS: '',
    THEME_BIO: '',
    THEME_VEGETABLES: '',
    THEME_RECIPE: 'інгредієнти-рецепти',
    THEME_PLATE: 'основна страва',
    THEME_ACC: 'підтримка',
    THEME_SNACK: 'снеки, перекус'
  },
  VEGETABLE: {
    DISCOVER_VEGETABLE: 'Відкрийте наші овочеві довідки',
    OURS_RECIPES: 'Наші рецепти',
    DISCOVER_ALSO: 'Відкрийте також...',
    SEE_ALL: 'Переглянути всі овочі',
    ON: 'Овочі з'
  },
  RECIPE: {
    'INGREDIENTS_LABEL ': 'Інгредієнти для {{value}} осіб',
    PEOPLES: ' {{value}} осіб',
    DIFFICULTY: { EASY: 'Легко', MEDIUM: 'Середньо', HARD: 'Складно' },
    COST: { CHEAP: 'Дешево', EXPENSIVE: 'Дорого' },
    TIMING: { MIN: 'Хв', HOURS: 'Година' },
    STEP: 'Крок',
    DISCOVER_ALSO: 'Відкрийте також...',
    HOME_SEE_MORE: 'Переглянути більше рецептів',
    SHOWCASE: 'Найкраще',
    HOME_BOOK: 'Наші рецепти',
    MIN_MORE: 'хв і +',
    HOUR_MORE: 'год і +',
    FILTER_BY_CRITERIA: 'Фільтрувати за критеріями',
    SORT_BY: 'Сортувати за:',
    BEST_RATED: 'Найвищий рейтинг',
    MOST_CONSULTED: 'Найбільш переглядувані',
    MEMBERS_RECIPES: 'Рецепти учасників',
    CRITERIA: 'Новинки',
    DISCOVER: { RECIPES: 'Відкрийте наші рецепти' },
    DISCOVER_RECIPE: 'Відкрити рецепт',
    INSTRUCTIONS: 'Інструкції',
    DEFAULT_TAG: 'Ідея рецепта',
    MOST_RECENT: 'Найновіші',
    RECIPE_VIDEOS: 'Відео рецептів',
    PRODUCT_ASSOCIATE: 'Рецепт з',
    BUDGET_LOW: 'Дешево',
    BUDGET_HIGH: 'Високо',
    BUDGET_MIDDLE: 'Середньо',
    PRINT_RECIPE: 'Надрукувати рецепт',
    LET_YOURSELF_SURPRISED: 'Дозвольте собі здивуватися',
    COOK_TIP_TITLE: 'Порада кухаря',
    ENJOY_MEAL: 'Смачного!',
    FILTER: { LEGEND: 'Легенда' },
    SURPRISE: 'Наші рецепти, які приємно вас здивують',
    DISCOVER_RECIPE_IDEAS: 'Відкрийте всі наші ідеї смачних страв',
    FAST: ' Швидко',
    PEOPLE: ' {{value}} людей ',
    VEGGIE: 'Вегетаріанський',
    VEGAN: 'Веганський'
  },
  PREDIGGO: {
    DIFFICULTY: { EASY: 'Легко', MEDIUM: 'Середньо', HARD: 'Складно' }
  },
  COOKIES: {
    TEXT: 'Продовжуючи перегляд цього сайту, ви погоджуєтесь на використання файлів cookie з технічних причин, для статистичного аналізу, управління трафіком, обміну інформацією з рекламодавцями з інших сайтів та надання актуальних рекламних повідомлень згідно з вашими інтересами.',
    CLOSE: 'Закрити',
    MORE: 'Дізнатися більше',
    AGREE_YOUTUBE: 'Щоб переглянути це відео, потрібно прийняти файли cookie YouTube',
    BUTTON_YOUTUBE: 'Прийняти файли cookie'
  },
  POPUP: { LAUNCH: 'ВІКНО-ВІДКРИТТЯ-САЙТУ' },
  FIELD_PLATE: { DISCOVER_VEGETABLE: 'Ознайомтеся з нашими овочевими довідками' },
  SEARCH: {
    OUR_RECIPES: 'Рецепти',
    OUR_PRODUCTS: 'Продукти',
    OUR_ARTICLES: 'Статті',
    RECIPES: 'Рецепти',
    PRODUCTS: 'Продукти',
    ARTICLES: 'Статті',
    ALL: 'Всі',
    SORT_BY: 'Сортувати за',
    RESULTS: 'результати',
    RESULT: 'результат',
    PRODUCT_OUT: 'продукти з',
    APPLY: 'Застосувати',
    FILTER: 'Фільтр',
    RECIPE_OUT: 'рецепти з',
    NO_RESULT: 'Білокачанна капуста за цим запитом... Ви ставите нам складне питання',
    SEE_MORE: 'Дивитися більше',
    DISCOVER_RECIPES: 'Ознайомтеся з нашими рецептами',
    SEE_MORE_OF: 'переглянути ще',
    DELETE: 'Видалити',
    SEE_ALL_PRODUCTS: 'Перегляньте всі продукти'
  },
  RECIPE_LIST: {
    OUR_RECIPES: 'Рецепти',
    RESULTS: 'Результати',
    SEE_MORE: 'Переглянути більше рецептів'
  },
  PRODUCT: {
    BUTTON: {
      ACTU: 'новини продуктів',
      FOUND: 'Де знайти цей продукт',
      DISCOVER: 'ознайомтеся з усім асортиментом'
    },
    NUTRITIONAL_VALUE: 'харчова цінність',
    CONDITIONING: 'фасування',
    PORTIONS: 'порції',
    NET_WEIGHT: 'маса нетто',
    DRY_WEIGHT: 'маса нетто без рідини',
    INGREDIENTS: 'інгредієнти',
    OUR_RECIPES: 'Ознайомтеся з нашими рецептами',
    FOR: 'Для',
    PER_PORTION: 'та на порцію',
    ENERGY: 'енергія',
    FAT: 'жири',
    SATURATE: 'насичені жири',
    GLUCIDES: 'вуглеводи',
    FIBER: 'харчові волокна',
    PROTEINS: 'білки',
    SALT: 'сіль',
    DISCOVER_ALSO: 'відкрийте також...',
    MORE_INFORMATION: 'більше інформації',
    TRACES: 'Сліди',
    CONTAINS: 'Містить',
    SLIDER: { SHEET: 'переглянути листок', BUY: 'купити цей продукт' },
    NUTRISCORE: 'інформація про Nutri-Score',
    TRIMAN: 'інформація про Triman',
    AGRICONFIANCE: 'інформація про Agriconfiance',
    BIO: 'інформація про біо',
    PESTICIDE_FREE: '',
    LEAF: '',
    LOCK: '',
    SEE_ALL: 'Відкрийте для себе наші продукти',
    LEGISLATION: 'відповідно до чинного законодавства',
    PORTION: { SINGULAR: 'порція', PLURAL: 'порції' },
    DISCLAIMER: '',
    COOKING: 'приготування',
    CONSERVATION: 'зберігання'
  },
  FAQ: {
    ON: 'запитання щодо',
    ALL: 'Всi',
    SEE_MORE: 'переглянути більше запитань',
    TITLE_1: 'Усі відповіді на ваші запитання',
    TITLE_2: 'У вас є запитання щодо певного продукту?',
    LINK_LABEL: 'Напишіть нам',
    BACK_TO_FAQ: 'Назад до поширених запитань '
  },
  FORM: {
    GO_TO_STEP: 'Перейти до кроку',
    STEP: 'Крок',
    RECEIVE_EMAIL_COPY: 'Отримати копію на електронну пошту',
    SEND: 'Надіслати',
    GDPR: 'Докладніше про обробку ваших даних',
    ERROR: 'Усі поля, позначені *, мають бути заповнені та дійсні',
    SEND_ERROR: 'Сталася помилка, спробуйте ще раз через кілька хвилин',
    UPLOAD_ERROR: 'Ваш запит не вдалося надіслати. Під час завантаження вкладення сталася технічна помилка. Будь ласка, спробуйте пізніше. Якщо проблема не зникне, зв’яжіться з нами, щоб ми могли вам допомогти.',
    THIRDPARTY_SERVICE_ERROR: 'Ваш запит не вдалося передати. Під час надсилання вашого повідомлення нашим командам сталася технічна помилка. Будь ласка, спробуйте пізніше. Якщо проблема не зникне, зв’яжіться з нами повторно.',
    NOTICE: 'Для належного розгляду вашої заявки Bonduelle може, залежно від ситуації, запросити медичні дані. Їх надання не є обов’язковим, ви маєте право не передавати їх.',
    SENDING: 'Надсилання форми...',
    LOADING: 'Завантаження...',
    PRODUCT_INFORMATION_TITLE: 'Інформація про продукт',
    PRODUCT_INFORMATION: {
      SEO_TITLE: ' Інформація про продукт | Bonduelle',
      SEO_DESC: "Зв'язатися зі службою підтримки клієнтів"
    },
    INFORMATIONS: 'ваша інформація',
    MISTER: 'Пане',
    MISS: 'Пані',
    NAME: 'Прізвище',
    OUR_NAME: 'Ваше прізвище',
    FIRSTNAME: 'Імʼя',
    OUR_FIRSTNAME: 'Ваше ім’я',
    MAIL: 'Ваша електронна пошта',
    MAIL_PLH: 'mail@address.com',
    MAIL_CONFIRM: 'підтвердьте свою електронну пошту',
    MAIL_ERROR: 'введіть дійсну електронну адресу',
    MAIL_ERROR_CONFIRM: 'підтвердьте вашу електронну адресу',
    ADDRESS: 'ваша адреса',
    STREET_PLH: '',
    STREET: 'Вулиця та номер будинку',
    ADDRESS_COMPLEMENT: 'додаткова інформація про адресу',
    ADDRESS_COMP_PLH: 'додаткова інформація про адресу',
    ZIPCODE: 'поштовий індекс',
    CITY: 'місто',
    CITY_PLH: 'ваше місто',
    PHONE: 'телефон',
    PHONE_PLH: 'номер телефону',
    COUNTRY: 'країна',
    PRODUCT_INFORMATIONS: 'інформація про продукт',
    PRODUCT_INFORMATION_DESC: 'Щоб наші служби могли якнайкраще розглянути ваш запит, будь ласка, вкажіть таку інформацію:',
    PRODUCT: {
      DETAIL: {
        DESC: 'Для кожного зазначеного критерію ви можете заповнити поле форми й додати ілюстративне фото. Важливо: на фото мають бути чітко видимі штрихкод, номер партії та термін придатності продукту.'
      },
      NOTE: {
        TITLE: 'Залишити зауваження щодо продукту',
        SEO_TITLE: 'Зауваження та коментар щодо продукту | Bonduelle',
        SEO_DESC: "Маєте зауваження чи коментар до продукту з нашого асортименту? Зв'яжіться зі службою підтримки споживачів — ми надамо індивідуальну відповідь протягом 48 годин."
      }
    },
    PRODUCT_RANGE: 'Відповідна категорія продуктів',
    PRODUCT_NAME: 'Назва продукту',
    PRODUCT_NAME_PLH: 'Напишіть назву продукту Bonduelle, якого стосується ваш запит',
    PRODUCT_INFORMATIONS_DETAIL: 'Детальна інформація',
    PRODUCT_INFORMATIONS_LABEL: 'Штрихкод продукту',
    PRODUCT_INFORMATIONS_PLH: 'Штрихкод складається з 13 цифр, розміщених на упаковці продукту.',
    PRODUCT_LOT: 'Номер партії продукту',
    PRODUCT_LOT_INFO: 'Номер партії розміщено поруч із датою кінцевого терміну споживання та складається з кількох літер і цифр, розміщених у кілька рядків. Він завжди починається з літери «L». Наприклад: L72450492107:13',
    PHOTO: 'Додати фото',
    EXPIRED_DATE: 'Дата "вжити до"',
    EXPIRED_DATE_ERROR: 'Введіть дійсну дату у форматі дд/мм/рррр',
    EXPIRED_DATE_DESC: 'Кінцева дата оптимального використання та кінцевий термін споживання вказані у вигляді дати.',
    PHOTO_MORE: 'Додаткові фото',
    MESSAGE: 'Ваше повідомлення',
    OUR_MESSAGE: 'Напишіть ваше повідомлення',
    SALES_OPERATIONS: {
      TITLE: 'Інформація про комерційну акцію',
      SEO_TITLE: 'Актуальна інформація про акції: конкурси… | Bonduelle',
      SEO_DESC: "Зв'яжіться з нашою службою підтримки для отримання інформації про поточну комерційну акцію. Відповідь протягом 48 годин."
    },
    PRESS_SERVICE: 'Зв’язатися з пресслужбою',
    FOOD_SERVICE: 'Зв’язатися з командою Bonduelle Food Service',
    BUSINESS_INFORMATION: 'Отримати зразки/купони на знижку/рекламну продукцію',
    MODAL_INFORMATION: 'Дякуємо за ваш інтерес до бренду.\n' +
      'Наразі ми не маємо купонів на знижку чи зразків для надсилання. Проте ми запрошуємо вас стежити за нами у Facebook та Instagram.\n' +
      'Таким чином ви зможете дізнаватися про розіграші та акції з розповсюдження зразків, які ми час від часу проводимо — і, можливо, потрапите до списку наших щасливих переможців!\n' +
      'Бажаємо удачі!\n',
    JOB_OFFER: { TITLE: '', SEO_TITLE: '', SEO_DESC: '' },
    WEB_SUGGESTION: {
      TITLE: 'Зробити пропозицію щодо сайту',
      SEO_TITLE: 'Повідомлення про покращення, пропозиція щодо сайту | Bonduelle',
      SEO_DESC: 'Будь ласка, зв’яжіться з нашою службою підтримки споживачів, щоб допомогти нам покращити сайт.\n'
    },
    ANOTHER: {
      TITLE: 'Зробити інший запит',
      SEO_TITLE: 'Контакт для будь-якого іншого запиту, служба | Bonduelle',
      SEO_DESC: 'Зв’яжіться з нашою службою підтримки споживачів для отримання інформації, послуги або пропозиції. Персоналізована відповідь протягом 48 годин'
    },
    AMBASSADOR: 'Стати амбасадором Bonduelle',
    CATEGORY: {
      SALAD: 'Салат',
      FROZEN: 'Заморожені',
      CAN: 'Консервовані',
      TAKEAWAY: 'Страви на виніс',
      VEGETABLE: ''
    },
    ACCESSIBILITY: {
      SEO_TITLE: 'Заява про доступність',
      SEO_DESC: 'Заява про доступність'
    }
  },
  CONTACT: {
    TITLE: 'До ваших послуг',
    SPECIAL_INFO: '',
    TAKE_CARE: '',
    BY_MAIL: 'За телефоном і ел.адресою',
    BY_PHONE: 'Дистрибутори',
    BY_SOURDLINE: '',
    MAIL_TEXT: 'Гаряча лінія для споживачів: 0-800-502-333<br>\n' +
      'Ел.адреса: <a class="underline" href="mailto:ukraine@bonduelle.com">ukraine@bonduelle.com</a>',
    PHONE_TEXT: '<b>Дистрибутор консервованої продукції</b><br>\n' +
      'ТОВ "Лан-Україна"<br>\n' +
      'Україна, 04116, м. Київ, вул. Митрофана Довнар-Запольського, 5<br>\n' +
      'тел. +38 (044) 236-95-55, +38 (044) 455-99-45<br>\n' +
      'факс +38 (044) 484-68-76<br>\n' +
      '<a class="underline" href="mailto:info@lanukr.com">info@lanukr.com</a><br>\n' +
      '<a class="underline" href="www.lanukr.com">www.lanukr.com</a><br>\n' +
      '<br>\n' +
      '<b>Дистрибутор консервованої продукції</b><br>\n' +
      'ТОВ "ОЛІВ ЛАЙН Україна"<br>\n' +
      'Україна, 08135, Київська обл., с. Чайки, вул. Валентини Чайки,16<br>\n' +
      'тeл. +38 (044) 593-31-01<br>\n' +
      'факс +38 (044) 593-31-02<br>\n' +
      '<a class="underline" href="mailto:info@oliveline.com.ua">info@oliveline.com.ua</a><br>\n' +
      '<a class="underline" href="www.oliveline.com.ua">www.oliveline.com.ua</a><br>\n' +
      '<br>\n' +
      '<b>Дистрибутор замороженої продукції</b><br>\n' +
      'ТОВ "Вічунай-Україна"<br>\n' +
      'Україна, 03058, м. Київ, вул. Гарматна, 39В<br>\n' +
      'тeл./факс +38 (044) 537-28-18<br>\n' +
      '<a class="underline" href="www.fb.com/viciukraine">www.fb.com/viciukraine</a>',
    SOURDLINE_TEXT: 'Для людей з порушенням слуху ми доступні через вебкамеру або чат з понеділка по п’ятницю з 9:00 до 18:00.',
    BY_DISTRIBUTOR: '',
    BY_DISTRIBUTOR_TEXT: '',
    SUBTITLE: 'Ви хочете зв’язатися з нами щодо:',
    AGREEMENT: 'Відповідно до Закону №78-17 від 6 січня 1978 року про інформаційні технології, файли даних та громадянські свободи (зі змінами) та Загального регламенту про захист даних (GDPR, ЄС) 2016/679, інформація, зібрана за допомогою цієї форми, призначена для обробки вашого запиту і/або звернення та підлягає обробці в електронному вигляді компанією Bonduelle, яка виступає контролером даних.\n' +
      '\n' +
      'Ці персональні дані збираються для задоволення законного інтересу Bonduelle і призначені для команд компанії, які займаються обслуговуванням споживачів, забезпеченням якості, маркетингом і цифровими сервісами, а також для обробників, що діють від її імені, деякі з яких можуть перебувати за межами Європейського Союзу.\n' +
      '\n' +
      'Ми зберігаємо ваші персональні дані протягом періоду, необхідного для обробки вашого запиту, а потім, у разі потреби, архівуємо їх на строк, що дозволяє нам дотримуватись юридичних зобов’язань або відповідає строкам позовної давності (а саме 5 років).',
    READ_MORE: 'Крім того, ви маєте право у будь-який момент звернутися до BONDUELLE з проханням реалізувати ваші права на доступ, виправлення, видалення та перенесення ваших персональних даних, а також права на обмеження та заперечення проти їх обробки.\n' +
      '\n' +
      "Щоб скористатися своїми правами щодо персональних даних, будь ласка, надішліть запит на електронну адресу: Dpo\\_france(at)bonduelle(dot)com або поштою за наступною адресою: для уповноваженої особи з питань захисту даних, Bonduelle, Rue Nicolas Appert, PO Box 30173, F-59653 Villeneuve D'Ascq.\n" +
      '\n' +
      'Щоб дізнатися більше про те, як BONDUELLE збирає та використовує ваші персональні дані, натисніть тут.',
    READ_MORE_LABEL: 'Читайте також',
    SATISFACTION_TEXT: 'Щоб зв’язатися з вами після коментаря щодо наших продуктів, розглянути вашу скаргу та надіслати вам, за вашим бажанням, анкету задоволеності, ми будемо обробляти надану інформацію як контролер даних. Юридичною підставою для обробки вашого запиту є ваша згода через можливі дані про стан здоров’я, які ви можете нам надати. Ця інформація зберігатиметься стільки, скільки потрібно для обробки вашого запиту, і до 5 років для підтвердження факту обробки запиту та виконання наших юридичних зобов’язань. Юридичною підставою для надсилання анкети задоволеності також є ваша згода. Ця інформація зберігатиметься стільки, скільки потрібно для її надсилання, але не більше одного року.',
    SATISFACTION_CHECKBOX: 'Позначивши цей чекбокс, ви погоджуєтеся отримати анкету задоволеності (що містить лише одне питання) після обробки вашого запиту. Це необов’язково.',
    CHECKBOX_TEXT: 'Позначивши цей чекбокс, ви погоджуєтеся на обробку Bonduelle персональних медичних даних, які ви можете надати у вашому повідомленні, з єдиною метою — відповісти на ваш запит. Це є обов’язковим для обробки вашого запиту.',
    PHONE: 'Безкоштовна цілодобова гаряча лінія [0-800-502-333]',
    CALL_US: 'Зателефонувати нам',
    TO_WRITE: 'Написати нам',
    PHONE_NUMBER: '0-800-502-333',
    SUCCESS_MESSAGE: 'Дякуємо! Ваше повідомлення було надіслано нашій команді. Його буде опрацьовано протягом 2–3 днів, без урахування вихідних і святкових днів.\n' +
      '\n' +
      'Ми залишаємося до ваших послуг з понеділка по п’ятницю з 9:00 до 18:00 за номером 330970252222 (дзвінок без додаткової оплати).\n' +
      '\n' +
      'У рамках контролю якості всі наші розмови можуть записуватись.',
    PHOTOERROR: { MESSAGE: '' }
  },
  GLOBAL: { READ_MORE: 'Дізнатися більше' },
  FLOWBOX: {
    GENERIC_KEY: 'ba_GnGC3TKedKEe0-gKomQ',
    PRODUCT_KEY: '1hRXF7TUSt-fhhlJASv-TQ',
    RECIPE_KEY: 'Ulp6NW8-QFOoSa61nBIlaA',
    HOME_KEY: 'g7--tXG3QgiwJjjpsaMmrg'
  },
  TOKEN: {
    FACEBOOK: '',
    PAGE_FACEBOOK_ID: '',
    INSTAGRAM: '',
    INSTA_ID: '17841407279489116',
    YOUTUBE: '',
    TWITTER: '',
    MAGAZINE: '6318061952.9bbab10.8842be1c95904c9d80ff59765a3a2ccc'
  },
  COOKIE: {
    BANNER: {
      MANDATORY: 'Потрібно',
      ANALYTICS: 'Аналіз',
      MARKETING: 'Маркетинг',
      SOCIAL_MEDIA: 'Соціальні мережі',
      ACCEPT: 'Прийняти всі',
      REJECT: 'Відхилити всі',
      SET_UP: 'Встановити',
      MANDATORY_DETAILS: 'Необхідні файли cookie потрібні для функціонування сайту, наприклад, щоб зберігати вашу інформацію для входу та забезпечувати безпечне з’єднання.\n' +
        'Файли cookie, необхідні для використання сайту Bonduelle.ua:\n' +
        '\n' +
        '<ul>  \n' +
        '<li>Сесійні cookie (SESSION_ID): це cookie, які генеруються застосунками на базі PHP. Вони є універсальними ідентифікаторами, що використовуються для керування змінними сесії користувача. Це випадково згенероване число, спосіб його використання може відрізнятись залежно від сайту, але типовий приклад — збереження статусу входу користувача між сторінками.</li>  \n' +
        '</ul>',
      ANALYTICS_DETAILS: 'Функціональні файли cookie допомагають нам оптимізувати сайт, наприклад, збирати статистику, зберігати ваші налаштування для соціальних взаємодій або вимірювати продуктивність і стабільність нашого застосунку. <br>\n' +
        'Аналітичні файли cookie, які використовуються на сайті bonduelle.com:\n' +
        '\n' +
        '<ul>  \n' +
        '<li>DoubleClick: цей cookie встановлюється DoubleClick (який належить Google) для створення профілю інтересів відвідувача сайту та відображення релевантної реклами на інших сайтах. Основна діяльність компанії — обмін рекламними оголошеннями в режимі реального часу від Google.</li>  \n' +
        '<li>Google Analytics: ці файли cookie дозволяють відстежувати найбільш відвідувані сторінки та трафік сайту.</li>  \n' +
        '<li>UTMTracking: цей cookie забезпечує керування змінними UTM для оптимального відстеження різних онлайн-рекламних кампаній.</li>  \n' +
        '</ul>',
      MARKETING_DETAILS: 'Маркетингові файли cookie дозволяють нам відстежувати ваші вподобання щодо рецептів і продуктів, щоб завжди пропонувати вам ті товари, які найкраще відповідають вашим запитам. <br>\n' +
        'Маркетингові файли cookie, що використовуються на сайті Bonduelle.ua:\n' +
        '\n' +
        '<ul>  \n' +
        '<li>Prediggo: цей інструмент використовує cookie SESSION_ID, щоб запропонувати вам продукти та рецепти, які найкраще відповідають вашій навігації та пошуковим запитам.</li>  \n' +
        '<li>ClickToBuy: цей cookie дозволяє зберігати вашу геолокацію, щоб запропонувати найближчі магазини, де доступні продукти Bonduelle, які ви шукаєте.</li>  \n' +
        '<li>Соціальні мережі: ці файли cookie дозволяють відображати «Соціальну стіну» Bonduelle на головній сторінці сайту. Ця «стіна» дає змогу побачити всі останні публікації з основних соціальних мереж, які використовує команда Bonduelle.</li>  \n' +
        '<li>FlowBox: цей cookie дозволяє використовувати функції платформи Flowbox, яка дозволяє нам демонструвати нашим відвідувачам рецепти та ідеї приготування від інших користувачів, що використовують продукцію Bonduelle.</li>  \n' +
        '</ul>',
      V2: 'Ок'
    },
    MODAL: {
      TITLE: 'Файли cookie',
      TEXT: 'Група Bonduelle прагне забезпечити захист персональних даних користувачів своїх вебсайтів, зокрема сайту Bonduelle.ua.\n' +
        'Щоб надати вам можливість користуватися послугами, які пропонує сайт — такими як перегляд продуктів, відкриття нових гастрономічних рецептів, підписка на певні сервіси, зокрема на наші інформаційні розсилки, — а також для оптимізації використання сайту та персоналізації відповідно до вашого профілю, сайт використовує файли cookie.\n' +
        "Група Bonduelle повністю зобов'язується забезпечити високий рівень захисту таких персональних даних і дотримуватись усіх чинних правил щодо захисту даних під час їх обробки в рамках використання свого вебсайту.\n" +
        'Таким чином, ви можете активувати або деактивувати файли cookie в будь-який момент.',
      CONFIG: 'Конфігурація',
      SAVE: 'Зберегти'
    }
  },
  LINK: { JOB_OFFERS: '' },
  CLIC2BUY: {
    INFOS: 'Щоб перелічити торгові точки, де продаються наші продукти, ми повинні використовувати спеціальний cookie-файл, який дозволяє передати код продукту нашому партнеру. Будь ласка, підтвердіть збереження файлів cookie, натиснувши кнопку «Підтвердити файли cookie». <br><br>\n' +
      'Дякуємо за розуміння.'
  },
  HOMEPAGE: {
    SLOGAN: 'Let good win',
    DISCOVER: 'Відкрийте наші надихаючі та смачні овочеві рецепти',
    FIND_RECIPE: 'Знайдіть рецепт',
    NEW_RECIPES: 'Перегляньте нові рецепти',
    FEAT_RECIPES: 'Рекомендовані рецепти',
    ALL_RECIPES: 'Перегляньте всі наші рецепти',
    VEGGIES_FOR: 'Наші овочі для…',
    RANGE_DISCOVER: 'Відкрийте наші лінійки продуктів',
    COMMITMENT: 'Наші зобов’язання',
    CARE_AND_PASSION: "Овочі, вирощені з турботою та любов'ю",
    TECHNOLOGIES: 'Технології, створені для забезпечення якості та безпеки смачних продуктів',
    BIODIVERSITY: 'Аграрні ланцюги створення вартості, побудовані разом із нашими фермерами-партнерами та підтримувані нашими експертами-агрономами.',
    DISCOVER_COMMINTMENTS: 'Дізнайтеся про наші зобов’язання',
    FIND_PRODUCT: 'Знайти продукт'
  },
  ABOUT: { NEWS: 'Перегляньте всі наші новини' },
  STATS: {
    GENERATIONS: '7 поколінь родини Bonduelle з 1853 року',
    PRODUCERS: ' 96,7% виробників підписали Агрономічну угоду Bonduelle (джерело: звіт про корпоративну соціальну відповідальність 24-25)',
    BCORP: 'Компанія Bonduelle є власником глобальної сертифікації B Corp.',
    TRANSITION: 'Надихаємо на перехід до раціону, багатого на продукти рослинного походження',
    TRANSITION_TITLE: 'Перехід'
  },
  COMITMENT: { TITLE: { UP: 'Наше зобов’язання', DOWN: 'для вас' } },
  BREADCRUMB: { HOME: 'Головна' },
  FOOTNOTES: { ABOUT_US: '' },
  AI: {
    DESIGNED_PRODUCED: 'Візуальний контент розроблено нашою командою та створено за допомогою ШІ',
    DESIGNED_RETOUCHED: 'Візуальний контент розроблено нашою командою та відредаговано за допомогою ШІ',
    GENERATED: 'Візуальний контент, згенерований ШІ',
    RETOUCHED: 'Візуальний контент, відредагований за допомогою ШІ',
    BACKGROUND_GENERATED: 'Фоновий візуальний контент, згенерований ШІ',
    BACKGROUND_RETOUCHED: 'Фоновий візуальний контент, відредагований за допомогою ШІ',
    PRODUCT_GENERATED: 'Візуальний контент продукту, згенерований ШІ',
    PRODUCT_RETOUCHED: 'Візуальний контент продукту, відредагований за допомогою ШІ',
    VIDEO_DESIGNED_PRODUCED: 'Відео розроблено нашою командою, створено за допомогою ШІ',
    VIDEO_DESIGNED_RETOUCHED: 'Відео, розроблене нашою командою та оброблене за допомогою ШІ',
    VIDEO_GENERATED: 'Відео, згенероване ШІ',
    VIDEO_RETOUCHED: 'Відео, оброблене ШІ'
  }
};
